import { RESEARCH, GET_RESEARCH_CATEGORY } from "../actions/Actions";

const initalState = {
  listLoader: false,
  listCount: null,
  list: [],

  researchLoader: false,
  researchList: [],
};

export function researchReducer(state = initalState, action) {
  const { type, payload } = action;

  switch (type) {
    case RESEARCH.LOADING:
      return {
        ...state,
        listLoader: true,
      };
    case RESEARCH.SUCCESS:
      return {
        ...state,
        listLoader: false,
        listCount: payload.total,
        list: payload,
      };
    case RESEARCH.ERROR:
      return {
        ...state,
        listLoader: false,
        list: [],
      };

    case GET_RESEARCH_CATEGORY.LOADING:
      return {
        ...state,
        researchLoader: true,
      };
    case GET_RESEARCH_CATEGORY.SUCCESS:
      return {
        ...state,
        researchLoader: false,
        researchList: payload.rows,
      };
    case GET_RESEARCH_CATEGORY.ERROR:
      return {
        ...state,
        researchLoader: false,
      };

    default:
      return state;
  }
}
